import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const CUMULATIVE_ISSUED_AMOUNT_TOKEN_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.cumulativeIssuedAmountToken,
    label: "Cumulative Issued Amount",
    tooltip: CatalogMetricSlugs.cumulative_issued_amount_token,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.cumulativeIssuedAmountToken,
    width: 200,
    render: (item) => {
        const measure = getMeasureValue(item, "cumulative_issued_amount_token");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
                significantDigits={2}
            />
        );
    },
};

export const CUMULATIVE_ISSUED_AMOUNT_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.cumulativeIssuedAmountDollar,
    label: "Cumulative Issued Amount ($)",
    tooltip: CatalogMetricSlugs.cumulative_issued_amount_dollar,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.cumulativeIssuedAmountDollar,
    width: 200,
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "cumulative_issued_amount_dollar",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};
